let Barba = require('barba.js');
import Swiper from 'swiper/dist/js/swiper';
import lightGallery from 'lightgallery/dist/js/lightgallery-all';

module.exports = Barba.BaseView.extend({
    namespace: 'event-page',

    onEnterCompleted: function () {
        new Swiper('.swiper-container', {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 3,
            spaceBetween: 15,
            navigation: {
                nextEl: '.about__gallery-arrow_right',
                prevEl: '.about__gallery-arrow_left',
            },
            breakpoints: {
                767: {
                    slidesPerView: 1,
                    spaceBetween: 30
                }
            }
        });

        $('#lightgallery').lightGallery({
            thumbnail: false,
            fullScreen: false,
            autoplay: false,
            autoplayControls: false,
            counter: false,
            download: false,
            zoom: false,
            share: false,
        });

        // Barba.Pjax.preventCheck = function(evt, element) {
        //     if (!Barba.Pjax.originalPreventCheck(evt, element) || $(element).hasClass('no-barba')) {
        //         return false;
        //     }
        //     return $(element).closest('#yii-debug-toolbar').length !== 0;
        // };
    },

    onLeave: function () {

    }
});



// WEBPACK FOOTER //
// resources/assets/src/js/views/event-page.js